import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/gbl-logo.png';

const NEXT_STEPS = [
  'Complete your profile with course details',
  'Our advisor will review your application',
  "We'll call you within 24-48 hours",
];

export default function SuccessPage() {
  const { signOutUser } = useAuth();

  useEffect(() => {
    const timer = setTimeout(() => window.location.reload(), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-4">
      <div className="w-full max-w-md animate-slide-up">
        <div className="bg-white rounded-lg shadow-auth border border-[#DADCE0] overflow-hidden">
          <div className="p-8 text-center">
            <img src={logo} alt="GBL" className="h-8 mx-auto mb-6" />

            {/* Success icon */}
            <div className="relative mx-auto w-20 h-20 mb-5">
              <div className="absolute inset-0 rounded-full bg-[#E6F4EA] animate-ping opacity-30" />
              <div className="relative w-20 h-20 rounded-full bg-[#1E8E3E] flex items-center justify-center">
                <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>

            <h1 className="text-xl font-medium text-[#202124] mb-2">Application Submitted!</h1>
            <p className="text-[#5F6368] text-sm leading-relaxed">
              Thank you! Our team has received your details. Let's complete your profile next.
            </p>

            <div className="bg-[#F8F9FA] rounded-lg p-4 mt-6 mb-6 text-left border border-[#E8EAED]">
              <p className="text-xs font-medium text-[#5F6368] uppercase tracking-wider mb-3">What happens next</p>
              {NEXT_STEPS.map((step, i) => (
                <div key={i} className="flex items-start gap-3 py-1.5">
                  <div className="w-5 h-5 rounded-full bg-[#1A73E8] text-white flex items-center justify-center text-[10px] font-medium flex-shrink-0 mt-0.5">
                    {i + 1}
                  </div>
                  <span className="text-sm text-[#3C4043]">{step}</span>
                </div>
              ))}
            </div>

            {/* Auto-redirect notice */}
            <div className="flex items-center justify-center gap-2 text-sm text-[#1A73E8] mb-4">
              <div className="w-4 h-4 border-2 border-[#1A73E8] border-t-transparent rounded-full animate-spin" />
              Redirecting to profile setup...
            </div>

            <button
              onClick={signOutUser}
              className="btn-secondary w-full gap-2"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
